"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRESTAddressToSDKAddress = exports.transformSDKAddressToRESTAddress = void 0;
const utils_js_1 = require("../utils.js");
function transformSDKAddressToRESTAddress(payload) {
    return (payload &&
        (0, utils_js_1.removeUndefinedKeys)({
            city: payload.city,
            subdivision: payload.subdivision,
            country: payload.country,
            postalCode: payload.postalCode,
            formattedAddress: payload.formatted,
            geocode: payload.location,
            addressLine: payload.addressLine1,
            addressLine2: payload.addressLine2,
            streetAddress: payload.streetAddress && {
                name: payload.streetAddress.name,
                number: payload.streetAddress.number,
                apt: payload.streetAddress.apt,
            },
        }));
}
exports.transformSDKAddressToRESTAddress = transformSDKAddressToRESTAddress;
function transformRESTAddressToSDKAddress(payload) {
    return (payload &&
        (0, utils_js_1.removeUndefinedKeys)({
            formatted: payload.formattedAddress,
            location: payload.geocode,
            addressLine1: payload.addressLine,
            addressLine2: payload.addressLine2,
            streetAddress: payload.streetAddress && {
                name: payload.streetAddress.name,
                number: payload.streetAddress.number,
                apt: payload.streetAddress.apt,
            },
            city: payload.city,
            subdivision: payload.subdivision,
            country: payload.country,
            postalCode: payload.postalCode,
        }));
}
exports.transformRESTAddressToSDKAddress = transformRESTAddressToSDKAddress;
